export default "__VITE_ASSET__91e0af41__"